import { render, staticRenderFns } from "./ProductSubNav.vue?vue&type=template&id=1cdb5cf7&scoped=true&"
import script from "./ProductSubNav.vue?vue&type=script&lang=js&"
export * from "./ProductSubNav.vue?vue&type=script&lang=js&"
import style0 from "./ProductSubNav.vue?vue&type=style&index=0&id=1cdb5cf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb5cf7",
  null
  
)

export default component.exports